import React from 'react';
import { Shield, Scale, Users, Heart, Lock, Zap } from 'lucide-react';
import { missionValues } from '../mockData';

const iconMap = {
  Shield: Shield,
  Scale: Scale,
  Users: Users,
  Heart: Heart,
  Lock: Lock,
  Zap: Zap
};

const Mission = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-cyan-500 font-semibold text-sm uppercase tracking-wide">Our Foundation</span>
          <h1 className="text-5xl font-bold text-gray-900 mt-2 mb-6">MISSION AND VALUES</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our commitment to excellence is built on six fundamental principles that guide every decision we make
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {missionValues.map((value) => {
            const IconComponent = iconMap[value.icon];
            return (
              <div
                key={value.id}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-cyan-400 to-cyan-600 rounded-xl flex items-center justify-center mb-6 shadow-lg">
                  <IconComponent className="text-white" size={32} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {value.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Additional Info */}
        <div className="mt-20 bg-white rounded-2xl p-8 lg:p-12 shadow-lg">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Commitment</h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-6">
              The Forex Brokers Association is dedicated to fostering a marketplace where integrity, 
              transparency, and professionalism are not just ideals, but daily practices. We work 
              tirelessly to ensure that our members uphold the highest standards of conduct, creating 
              a trading environment that benefits all market participants.
            </p>
            <p className="text-gray-600 text-lg leading-relaxed">
              Through continuous education, advocacy, and enforcement of ethical guidelines, we strive 
              to build trust in the forex market and protect the interests of traders, brokers, and 
              financial institutions worldwide.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mission;